<template>
  <div class="order-item-form">
    <div
      id="new_order_item"
      novalidate="novalidate"
      class="simple_form new_order_item"
    >
      <div class="submit">
        <label>
          &#8203;
        </label>
        <div class="form-group">
          <input
            type="submit"
            name="commit"
            data-ga-event-category="Package-Form"
            data-ga-event-action="Submit"
            :value="formBtnText"
            :disabled="disableButton"
            class="btn btn-primary btn-block"
            @click="createOrderItem"
          >
        </div>
      </div>
    </div>
    <div id="app">
      <ClearQuoteCartModal
        v-show="isModalVisible"
        @close="closeModal"
        @confirm="modalConfirmed"
      />
    </div>

    <div class="errors">
      {{ errs }}
    </div>
  </div>
</template>

<script>
import Api from '../../cart/cart_api'
import ClearQuoteCartModal from './clear_quote_cart_modal'
import { mapActions, mapMutations } from 'vuex'

export default {

  components: {
    ClearQuoteCartModal
  },
  props: {
    formBtnText: {
      default: null,
      type: String,
    },
    idhotel: {
      default: null,
      type: Number,
    },
    idpackage: {
      default: null,
      type: Number,
    },
    idpackageoption: {
      default: null,
      type: Number,
    },
    idstay: {
      default: null,
      type: Number,
    },
    qtyhotel: {
      default: 0,
      type: Number,
    },
    qtypackage: {
      default: 0,
      type: Number,
    }},

  data() {
    return {
      disableButton: false,
      errs: null,
      isModalVisible: false
    }
  },

  computed: {
    hotelQty() {
      if (this.idhotel == null) {
        return 0
      } else {
        return this.qtyhotel
      }
    },

    cartDisabled(){
      return this.$store.state.order.order.disabled_cart
    },


    postBody() {

      return JSON.stringify({
        order_item: {
          hotel_id: this.idhotel,
          package_id: this.idpackage,
          package_option_id: this.idpackageoption,
          quantity: this.qtypackage,
          room_quantity: this.hotelQty,
          stay_id: this.idstay
        }
      })
    }
  },

  methods: {
    ...mapActions('order', ['getBackendOrder']),
    ...mapMutations('cart', ['displayCart']),
    showModal() {
      this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
    },
    createOrderItem() {
      if (this.disableButton) { return }

      if(this.cartDisabled) {
        this.showModal()
      } else {
        this.addOrderItem()
      }
    },
    modalConfirmed(){
      this.cartDisabled = false
      this.addOrderItem()
      this.closeModal()
    },
    addOrderItem(){
      this.disableButton = true
      this.errs = null

      Api.createOrderItem(this.postBody).then(response => {
        if (response.id) {
          this.getBackendOrder().then( order => {
            if (order.hotel_needed){
              window.location.href = `/cart/events/${order.h4h_event_id}/hotels`
            } else {
              this.displayCart()
            }
          })
        } else {
          this.errs = response.errors || this.$t('formPackage.error')
        }
        this.disableButton = false
      })
    }
  }
}
</script>
